//#region src/local-storage/set-local-item.ts
const setLocalItem = (key, value) => {
	if (value === void 0 || value === null) {
		localStorage.removeItem(key);
		return;
	}
	if (typeof value === "object") {
		localStorage.setItem(key, JSON.stringify(value));
		return;
	}
	localStorage.setItem(key, String(value));
};

//#endregion
export { setLocalItem };